import React, {useEffect, useState} from 'react';

const DepartmentSelect = ({ source, setDepartment }) => {
    const [value, setValue] = useState(0);

    const handleChange = (event) => {
        setValue(event.target.value);
        setDepartment(event.target.value);
    };

    useEffect(() => {
        let currentDepartment = document.getElementById('offers_list').dataset.active_department;
        if (currentDepartment !== undefined) {
            setValue(currentDepartment);
            setDepartment(currentDepartment);
        }
    }, []);

    if (undefined === source.departments) {
        return null;
    }

    return (
        <p>
            <label>Business Unit</label>
            <select id='departmentSelect' onChange={event => handleChange(event)} value={value} className="cr_filters_dd_ctr" name="ctr" size="3">
                <option value={0} key={0}>all units</option>
                {source.departments.map(department => (
                    <option key={department.id} value={department.id}>{department.name}</option>
                ))}
            </select>
        </p>
    );
};

export default DepartmentSelect;
